import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchComponent),
      multi: true
    }
  ]
})
export class SearchComponent implements OnInit {

  timer: any
  private _value: any
  @Output() search: EventEmitter<any> = new EventEmitter();
  @Output() selectedItem: EventEmitter<any> = new EventEmitter();
  @ViewChild('inputSearch', { static: true }) inputSearch: ElementRef<HTMLInputElement> | undefined;
  @Input() label: string | undefined;
  @Input() msgError: string | undefined;
  @Input() list: any[] = [];
  @Input() listDisplay: string | undefined;
  @Input() readonly: boolean = false;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  focus: boolean = false;
  dataShow: boolean = false

  constructor() { }


  ngOnInit() {
     // @ts-ignore
    this.inputSearch.nativeElement.addEventListener('keydown', (ev) => {
      clearTimeout(this.timer);
    })
    // @ts-ignore
    this.inputSearch.nativeElement.addEventListener('keyup', (ev) => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        // @ts-ignore
        this.search.emit(this.inputSearch.nativeElement.value);
      }, 500);
    })

    document.addEventListener('click', ev => {
      const el = <HTMLElement>ev.target
      if (!el.classList.contains('selectSearch')) {
        this.list = []
      }
    })


  }

  validate(): boolean {
    if (this.required) {
      // @ts-ignore
      if (this.value[this.listDisplay]) {
        this.msgError = ''
      } else {
        this.msgError = 'Campo requerido, seleccione una tienda valida'
      }
    }
    return this.msgError ? false : true
  }

  focusEv() {
    if (!this.readonly) {
      this.focus = true
    }
  }

  focusoutEv() {
    this.focus = false
  }

  selectItem(val: any) {
    this.value = val
    this.selectedItem.emit(val);
    this.list = []
  }






  get value() {
    return this._value ? this._value : {}
  }

  set value(v: any) {
    if (v !== this._value) {
      this._value = v
      this.onChange(v)
    }
  }

  onChange(v: any) { }

  onTouch() { }

  writeValue(obj: any): void {
    this._value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn
  }
  setDisabledState?(isDisabled: boolean): void { }

}
